import { render, staticRenderFns } from "./estates-list-form.vue?vue&type=template&id=85d820cc&scoped=true&"
import script from "./estates-list-form.vue?vue&type=script&lang=js&"
export * from "./estates-list-form.vue?vue&type=script&lang=js&"
import style0 from "./estates-list-form.vue?vue&type=style&index=0&id=85d820cc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d820cc",
  null
  
)

export default component.exports